// src/App.tsx
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import Gallery from './components/Gallery';
import FAQ from './components/FAQ';
import Contact from './components/Contact';

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <LanguageProvider>
      <Navbar />
      <Home />
      <About />
      <HowItWorks />
      <Benefits />
      <Gallery />
      <FAQ />
      <Contact />
    </LanguageProvider>
  </ThemeProvider>
);

export default App;
